import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "pop_up pop_detail",
  id: "find_account",
  style: {"display":"block"}
}
const _hoisted_2 = { class: "content_wrap sign_form" }
const _hoisted_3 = { class: "btn_wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "pop_up_layer find_account",
      style: {"display":"block"},
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "close_btn",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
      }, [...(_cache[3] || (_cache[3] = [
        _createElementVNode("img", {
          src: "img/close.png",
          alt: "닫기"
        }, null, -1)
      ]))]),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "pop_tit" }, [
        _createElementVNode("p", null, "개인정보 처리방침")
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"terms_content custom_scroll\" data-v-a12b4280><p data-v-a12b4280>개인정보 수집·이용 안내</p><br data-v-a12b4280><p data-v-a12b4280>다시함께상담센터는 「개인정보 보호법」에 따라 개인정보를 안전하게 관리하며, 수집 목적 외의 용도로 사용하지 않습니다.</p><br data-v-a12b4280><p class=\"ul_title\" data-v-a12b4280>1. 캠페인, 이벤트 참여</p><ul data-v-a12b4280><li data-v-a12b4280><p data-v-a12b4280>■ 수집 항목: 성명, 휴대전화번호, 이메일</p></li><li data-v-a12b4280><p data-v-a12b4280>■ 이용 목적: 참여 신청 확인, 참여자 및 당첨자 안내, 캠페인·이벤트 운영, 경품 발송, 결과 공유 및 문의 응대</p></li><li data-v-a12b4280><p data-v-a12b4280>■ 보유 기간: 캠페인 또는 이벤트 종료 후 3개월까지 보관 후 파기</p></li><li data-v-a12b4280><p data-v-a12b4280>■ 동의 거부 시: 개인정보 수집·이용에 동의하지 않을 수 있으나, 필수 항목에 동의하지 않을 경우 참여가 제한될 수 있습니다.</p></li></ul><br data-v-a12b4280><p class=\"ul_title\" data-v-a12b4280>2. 강연(성매매x크로스 등) 신청</p><ul data-v-a12b4280><li data-v-a12b4280><p data-v-a12b4280>■ 수집 항목: 성명, 휴대전화번호, 이메일, 연령</p></li><li data-v-a12b4280><p data-v-a12b4280>■ 이용 목적: 강연 신청 확인, 참여자 안내, 강연 운영 및 문의 응대</p></li><li data-v-a12b4280><p data-v-a12b4280>■ 보유 기간: 강연 종료 후 3개월까지 보관 후 파기</p></li><li data-v-a12b4280><p data-v-a12b4280> ■ 동의 거부 시: 개인정보 수집·이용에 동의하지 않을 수 있으나, 필수 항목에 동의하지 않을 경우 강연 신청이 제한될 수 있습니다.. </p></li></ul><br data-v-a12b4280><p class=\"ul_title\" data-v-a12b4280>3. 뉴스레터 수신</p><ul data-v-a12b4280><li data-v-a12b4280><p data-v-a12b4280>■ 수집 항목: 성명, 이메일</p></li><li data-v-a12b4280><p data-v-a12b4280>■ 이용 목적: 뉴스레터 발송, 구독자 관리 및 수신 여부 확인</p></li><li data-v-a12b4280><p data-v-a12b4280>■ 보유 기간: 뉴스레터 구독 해지 또는 수신 동의 철회 시까지 보관 후 파기</p></li><li data-v-a12b4280><p data-v-a12b4280>■ 동의 거부 시: 개인정보 수집·이용에 동의하지 않아도 캠페인, 이벤트 및 강연 참여에는 불이익이 없습니다.</p></li></ul><br data-v-a12b4280><p data-v-a12b4280> 뉴스레터 수신 원하지 않는 경우 언제든지 구독 해지 또는 수신 거부를 요청할 수 있으며, 구독 해지 시 관련 개인정보는 파기됩니다. 다만, 관계 법령에 따라 보관이 필요한 경우에는 해당 기간 동안 별도로 보관합니다. </p><br data-v-a12b4280><p data-v-a12b4280>다시함께상담센터는 개인정보 보호와 관련 문의 및 불만 처리를 위한 담당부서와 책임자를 지정하고 있습니다.</p><br data-v-a12b4280><p data-v-a12b4280>관련 문의: 다시함께상담센터 02-814-3660</p></div>", 1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "submit_btn",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
          }, "확인")
        ])
      ])
    ])
  ], 64))
}